export default "__VITE_ASSET__D9J_5FI6__"